import React from 'react';

const EstimationFormContext = React.createContext({});

export default EstimationFormContext;